export default __webpack_public_path__ + "static/media/discussion.90b90be4.png";